import { WizardStepProps } from '../../WizardStepProps';
import React, { useState } from 'react';
import { SignersStep } from '../../02_signersStep/SignersStep';
import { ConfirmationStep } from '../../04_confirmationStep/ConfirmationStep';
import { ProgressStep } from '../../shared/WizardProgress';
import { useWizardStep } from '../../useWizardStep';
import { CreateSigningAppointmentFormData } from '../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { NotaryForm } from './notaryForm/NotaryForm';
import { NotaryStepNavigation } from './NotaryStepNavigation';
import { FormTemplate } from '../../shared/FormTemplate';

export const NotaryStep: React.FC<WizardStepProps> = ({ wizardFormData, onClose, ...rest }) => {
  const [updatedWizardFormData, setUpdatedWizardFormData] = useState<CreateSigningAppointmentFormData>(wizardFormData);
  const { showNext, showPrevious, advance, goBack } = useWizardStep();
  const isDigSync = updatedWizardFormData.ownerType.includes('Email');

  if (showPrevious) {
    return <SignersStep wizardFormData={updatedWizardFormData} onClose={onClose} {...rest} />;
  }
  if (showNext) {
    return <ConfirmationStep wizardFormData={updatedWizardFormData} onClose={onClose} {...rest} />;
  }
  return (
    <FormTemplate progressStep={ProgressStep.METHOD} wizardFormData={wizardFormData}>
      <NotaryForm
        advance={advance}
        updatedWizardFormData={updatedWizardFormData}
        setUpdatedWizardFormData={setUpdatedWizardFormData}
        onClose={onClose}
        isDigSync={isDigSync}
      >
        <NotaryStepNavigation advance={advance} goBack={goBack} isDigSync={isDigSync} />
      </NotaryForm>
    </FormTemplate>
  );
};
